import React, { useState } from "react";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import Bluebutton from "../../components/blueButton/Bluebutton";
import Testimonial1 from "../../components/testimonial1/Testimonial1";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { Container, Row, Col } from "react-bootstrap";
import Arrow from "./Arrow3.png";
import Img1 from "./img1.png";
import Briefcase from "./ph_briefcase.png";
import Exchange from "./uil_exchange.png";
import OcticonGraph from "./octicon_graph-24.png";
import Icomoon from "./icomoon-free_cogs.png";
import Lightbulb from "./flowbite_lightbulb-outline.png";
import Trophy from "./iconoir_trophy.png";
import Shield from "./Shield.png";
import bgImage from "./bg1.png";
import Rectangle from "./Rectangle.png";
import ArrowTop from "./ArrowTop.png";
import Servicesvg1 from "./servicesvg1.png";
import Servicesvg2 from "./servicesvg2.png";
import Servicesvg3 from "./servicesvg3.png";
import Servicesvg4 from "./servicesvg4.png";
import "./services.css";
import {  FaBriefcase ,FaLaptopCode , FaStethoscope ,FaClipboard } from "react-icons/fa";

const Services3 = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone_number: "",
    email: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const services = [
    {
      title: "Talent Market Insights",
      description:
        "Understand the market trends to align recruitment strategies with industry dynamics.",
      icon: Servicesvg1,
      mainicon: <FaBriefcase className="servicesIcon" />,
    },
    {
      title: "Targeted Strategies",
      description:
        "Leverage data to build robust recruitment campaigns and attract top-tier candidates.",
      icon: Servicesvg2,
      mainicon: <FaLaptopCode className="servicesIcon" />,
    },
    {
      title: "Competitor Analysis",
      description:
        "Benchmark against competitors to gain insights on talent acquisition strategies.",
      icon: Servicesvg3,
      mainicon: <FaStethoscope className="servicesIcon" />,
    },
    {
      title: "Behavioral Insights",
      description:
        "Understand candidate preferences to improve the recruitment experience.",
      icon: Servicesvg4,
      mainicon: <FaClipboard className="servicesIcon" />,
    },
  ];
  return (
    <>
      <Navb />
      <Container
        className="aboutHeader row p-0 align-items-center justify-content-center"
        style={{ margin: "2rem auto" }}
      >
        <div className=" aboutHeaderText1 col-lg-6 col-md-10 col-sm-12 text-center text-lg-start">
          <div className="d-flex justify-content-center justify-content-lg-start gap-3 pb-2">
            <span
              style={{ "font-weight": "600", color: "var(--primary-color)" }}
            >
              Our Services
            </span>
          </div>
          <div
            className="Heading43 mt-2 mt-lg-0 mb-4"
            style={{ "line-height": "55px", color: "var(--primary-color)" }}
          >
            Shaping the Future of Effective Talent Acquisition
          </div>
          <div className="ms-1 ms-lg-5 pb-3">
            <div className="fw-bold" style={{ color: "var(--primary-color)" }}>
            Data-Driven Market Insights
            </div>
            <div>
            Unlock valuable insights with our comprehensive market research services, empowering your business to make informed decisions and stay ahead of the competition.
            </div>
          </div>
          <div className="ms-1 ms-lg-5">
            <div className="fw-bold" style={{ color: "var(--primary-color)" }}>
            Understanding Your Market Landscape
            </div>
            <div>
            Gain a deeper understanding of market trends, customer behaviors, and competitor strategies with our expert research, helping you navigate opportunities and risks effectively.
            </div>
            <div className="mt-3 mb-3 mb-lg-1 d-flex justify-content-center justify-content-lg-start">
              <Bluebutton Text="Get in Touch" Link="contact" />
            </div>
          </div>
        </div>
        <div
          className="aboutimgHeader col-lg-6 col-md-10  px-4"
          style={{ overflow: "hidden", borderRadius: "18px" }}
        >
          <img src={Img1} alt="Img1" style={{ width: "100%" }} />
        </div>
      </Container>

      <Container className="py-5">
        <div className="row justify-content-center">
          <div ccol-md-10>
            <div
              className="text-white"
              style={{
                backgroundImage: `url(${bgImage})`,
                borderRadius: "60px",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
            >
              <div className="p-5">
                <h2 className="text-center mb-4">
                Why Market Research Matters in Recruitment
                </h2>
                {/* <h5 className="mb-3">
                  What do you look for when you search for a job?
                </h5> */}
                <p>
                The landscape of talent acquisition is highly competitive today. Hence, market research recruitment stands out as a game-changer. It’s not just about filling positions; it’s about understanding the market, the competition, and the candidates themselves. This type of research empowers companies to make informed decisions, align recruitment strategies with industry trends, and ultimately, find the best fit for both the role and the company culture.
                </p>
                <p>
                We analyze the talent market, understand competitive positioning, and identify candidate motivations and behaviors. We explore techniques to harness market data for building robust recruitment campaigns and strategies that resonate with top-tier candidates. Using market research in recruitment, companies we identify skills gaps within their teams and the wider market. This knowledge is crucial for developing targeted training programs and hiring strategies to bridge these gaps. Benchmarking against competitors: B2B market research in recruitment involves understanding how competitors are attracting and retaining talent.
                </p>
                <p>
                This insight allows to refine their recruitment strategies and offer compelling propositions to candidates.
                </p>
               
              </div>
            </div>
          </div>
        </div>
      </Container>

      {/* <Container className="row serviceMidBackImg1 justify-content-center">
        <div className="col-md-10 col-sm-11">
          <div className="serviceMidText1">
            <h3> Why Market Research Matters in Recruitment</h3>
            <p>
              The landscape of talent acquisition is highly competitive today.
              Hence, market research recruitment stands out as a game-changer.
              It’s not just about filling positions; it’s about understanding
              the market, the competition, and the candidates themselves. This
              type of research empowers companies to make informed decisions,
              align recruitment strategies with industry trends, and ultimately,
              find the best fit for both the role and the company culture.{" "}
              <br />
              We analyze the talent market, understand competitive positioning,
              and identify candidate motivations and behaviors. We explore
              techniques to harness market data for building robust recruitment
              campaigns and strategies that resonate with top-tier candidates.
              Using market research in recruitment, companies we identify skills
              gaps within their teams and the wider market. This knowledge is
              crucial for developing targeted training programs and hiring
              strategies to bridge these gaps. Benchmarking against competitors:
              B2B market research in recruitment involves understanding how
              competitors are attracting and retaining talent. This insight
              allows to refine their recruitment strategies and offer compelling
              propositions to candidates.
            </p>
          </div>
        </div>
      </Container> */}
      <Container className="newSection">
        <p className="mt-5 text-center">
        Using market research in recruiting doesn’t just about understand the market; it’s also about improving the recruitment process itself. By understanding candidate behaviors and preferences, companies can streamline their recruitment process, making it more candidate-friendly.
        </p>
     
      </Container>

      <Container className="py-5">
        <Row className="g-4">
          {services.map((service, index) => (
            <Col xs={12} md={6} lg={6} key={index}>
              <div
                className="p-4 shadow-sm h-100 d-flex  gap-3"
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "15px",
                  backgroundColor: "#fff",
                }}
              >
                <div className="row align-items-center">
                  <div className="col-lg-6">
                  {service.mainicon}
                  </div>
                  <div className="col-lg-6">
                    <div>
                      <h5
                        className="fw-bold mb-2 mt-3 text-start text-sm-center text-md-center text-lg-start"
                        style={{ color: "var(--primary-color)" }}
                      >
                        {service.title}
                      </h5>
                      <p className="text-muted mb-3 text-start text-sm-center text-md-center text-lg-start">
                        {service.description}
                      </p>
                      <div className="d-flex align-items-center justify-content-between mt-auto">
                        <div
                          className="p-3 rounded-4"
                          style={{ border: "1px solid var(--primary-color)" }}
                        >
                          <img src={ArrowTop} alt="ArrowTop" />
                        </div>
                        <img src={service.icon} alt="service.icon" />
                        {/* <span className="text-primary">{service.icon}</span> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
      {/* <Container>
        <h1
          className="Heading43 mt-5"
          style={{ textAlign: "start", margin: "0rem 0rem 4rem 0rem" }}
        >
          Why choose Udaya Solutions permanent staffing solutions?
        </h1>
        <p>
          Udaya Solutions works with the best clients. We have highly skilled
          professionals who work hard looking after the demands of the
          companies. It is our unique knowledge and extraordinary approach that
          takes care of each employer and the employee through Udaya Slutions
          General Staffing. For Employers, recruiting new professionals is very
          easy with Udaya Solutions services. Of course, we are quick in our
          Staffing Solutions. That is why we train job enthusiasts with
          Temporary Staffing Solutions, to show true potential every day at
          their duties.
        </p>
      </Container>
      <h1
        className="Heading43 mt-5"
        style={{ textAlign: "center", margin: "0rem 0rem 4rem 0rem" }}
      >
        Executive Hiring
      </h1>
      <Container className="ourservicesasection">
        <div className="ourserviceitems">
          <img src={Briefcase} alt="Briefcase" />
          <div className="ourserviceitemstext">Executive Search</div>
          <p>
            We specialize in finding top executives to lead your business to
            success.
          </p>
        </div>
        <div className="ourserviceitems">
          <img src={Icomoon} alt="Icomoon" />
          <div className="ourserviceitemstext">Leadership Recruitment</div>
          <p>
            We focus on hiring senior leadership talent that aligns with your
            organization's vision and goals.
          </p>
        </div>
        <div className="ourserviceitems">
          <img src={OcticonGraph} alt="OcticonGraph" />
          <div className="ourserviceitemstext">C-Level Hiring</div>
          <p>
            Finding and recruiting C-level executives with the experience and
            leadership qualities your company needs.
          </p>
        </div>
        <div className="ourserviceitems">
          <img src={Exchange} alt="Exchange" />
          <div className="ourserviceitemstext">Executive Coaching</div>
          <p>
            We offer executive coaching services to ensure your new leaders
            succeed in their roles and grow with your company.
          </p>
        </div>
      </Container> */}

      <Footer />
    </>
  );
};

export default Services3;
